// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VXRF","top":"styles_top__2yZuj"};